import getCampaignBasics from "./getCampaignBasics.gql";
import getFundraiser from "./getFundraiser.gql";
import getAuthUser from "./userAuth.gql";
import getCampaignUpdates from "./getCampaignUpdates.gql";
import getCampaignUpdate from "./getCampaignUpdate.gql";
import getEditorCampaignUpdates from "./getEditorCampaignUpdates.gql";
import getCampaignComments from "./getCampaignComments.gql";
import getCampaignFeatureLinks from "./getCampaignFeatureLinks.gql";
export default getAuthUser;
export const GET_CAMPAIGN_BASICS = getCampaignBasics;
export const GET_FUNDRAISER = getFundraiser;
export const GET_CAMPAIGN_UPDATES = getCampaignUpdates;
export const GET_CAMPAIGN_UPDATE = getCampaignUpdate;
export const GET_EDITOR_CAMPAIGN_UPDATES = getEditorCampaignUpdates;
export const GET_CAMPAIGN_COMMENTS = getCampaignComments;
export const GET_CAMPAIGN_FEATURE_LINKS = getCampaignFeatureLinks;
